import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

interface CheckrErrorBottomSheetProps {
  modalState: UseModalState;
}

export function CheckrErrorBottomSheet(props: CheckrErrorBottomSheetProps) {
  const { modalState } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet header={<BottomSheetHeader onClose={handleClose} />} modalState={modalState}>
      <BottomSheetIllustrationContent
        title="We're having trouble starting your background check"
        description="Please try again in a moment"
        illustrationType="error"
      />
    </BottomSheet>
  );
}
